import React from 'react';
import PropTypes from 'prop-types';
import AsyncIcon from '@ux/icon/async-icon.js';
import { FormattedMessage } from '@godaddy/react-mintl';
import useConfig from '../lib/useConfig';
import Link from '@ux/link';

import './HubBanner.css';

function HubBanner({ appEid }) {
  const { hubUrl } = useConfig();
  const defaultTitle = 'HUB_BANNER_TITLE';
  const pageEid = appEid.extend('pcx_pro_hub_banner');
  const hubBannerLinkEid = pageEid('return_to_hub_button.click') || '';

  return (
    <div className='hub-banner'>
      <Link
        data-eid={ hubBannerLinkEid }
        href={ hubUrl }>
        <AsyncIcon icon='chevron-left' />
        <FormattedMessage id={ defaultTitle } />
      </Link>
    </div>
  );
}

HubBanner.propTypes = {
  appEid: PropTypes.func
};

export default HubBanner;
